import { AutoEnableIcon, InfoIcon } from '@assets/icons';
import { FormCard, FormToggle } from '@components/form';
import { Group } from '@components/layout';
import { Tooltip } from '@components/tooltip';
import { Typography } from '@components/typography';

export const AutoUpdateField = () => {
  return (
    <FormCard>
      <Group alignItems="center" justifyContent="space-between">
        <Group gap={1} alignItems="center">
          <AutoEnableIcon size={16} />
          <Typography variant="body2">Auto Update</Typography>
          <Tooltip title="Automatically apply platform updates to this server when it starts.">
            <InfoIcon size={10} />
          </Tooltip>
        </Group>
        <FormToggle name="autoUpdateEnabled" maintainGutters={false} />
      </Group>
    </FormCard>
  );
};
